import { render, staticRenderFns } from "./SchulteGrid.vue?vue&type=template&id=591a455e&scoped=true"
import script from "./SchulteGrid.vue?vue&type=script&lang=js"
export * from "./SchulteGrid.vue?vue&type=script&lang=js"
import style0 from "./SchulteGrid.vue?vue&type=style&index=0&id=591a455e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591a455e",
  null
  
)

export default component.exports